import type Fonts from '../types/fonts.type';

const fonts: Fonts = {
    primary: `'Bliss', Calibri, 'Trebuchet MS', sans-serif`,
    secondary: `'Bilo', 'Bliss', Calibri, 'Trebuchet MS', sans-serif`
};

export default fonts;
